import React from 'react'
import { Star, StarFill, StarHalf } from 'react-bootstrap-icons'

interface StarRatingProps {
  rating: number
  small?: boolean
}

const StarRating: React.FC<StarRatingProps> = ({ rating, small = false }) => {
  const fullStars = Math.floor(rating)
  const hasHalfStar = rating % 1 >= 0.5

  return (
    <span className="d-flex align-items-center justify-content-center w-100">
      {small && rating >= 4 && (
        <>
          <StarFill className="text-warning" />
          <span className="text-white ps-1">{Math.floor(rating * 10) / 10}</span>
        </>
      )}
      {small && rating < 4 && (
        <>
          <StarHalf className="text-warning" />
          <span className="text-white ps-1">{Math.floor(rating * 10) / 10}</span>
        </>
      )}
      {!small && (
        <div className="d-flex gap-2 justify-content-center align-items-center">
          {[...Array(5)].map((_, index) => {
            if (index < fullStars) {
              return (
                <StarFill
                  key={index}
                  className="text-warning"
                  style={{ width: '2rem', height: '2rem' }}
                />
              )
            } else if (index === fullStars && hasHalfStar) {
              return (
                <StarHalf
                  key={index}
                  className="text-warning"
                  style={{ width: '2rem', height: '2rem' }}
                />
              )
            } else {
              return (
                <Star
                  key={index}
                  className="text-warning"
                  style={{ width: '2rem', height: '2rem' }}
                />
              )
            }
          })}
        </div>
      )}
    </span>
  )
}

export default StarRating
